<template>
	<section class="placeholder">
		<span class="ph-dot"></span><span>{{ label }}</span>
	</section>
</template>
<script setup lang="ts">
	defineProps<{ label: string }>();
</script>
